function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'ivory': 'rgb(252, 252, 249)','green': 'rgb(54, 67, 31)',};

    this.images = {'ivory': 'url("//abcbrand.co/cdn/shop/files/IVORY_68x.png?v=10399691603032467988")','tangerine': 'url("//abcbrand.co/cdn/shop/files/TANGERINE_68x.png?v=15178671012320593011")','black': 'url("//abcbrand.co/cdn/shop/files/BLACK_68x.png?v=2372462643429160488")','white': 'url("//abcbrand.co/cdn/shop/files/WHITE_68x.png?v=3949457684557561021")','khaki': 'url("//abcbrand.co/cdn/shop/files/KHAKI_68x.png?v=2865953803972034106")','pink': 'url("//abcbrand.co/cdn/shop/files/PINK_68x.png?v=12628236210588614642")','grey-marle': 'url("//abcbrand.co/cdn/shop/files/GREYMARLE_68x.png?v=1899313120047425578")','raw-white': 'url("//abcbrand.co/cdn/shop/files/RAWWHITE_68x.png?v=14020128990439231775")','blue': 'url("//abcbrand.co/cdn/shop/files/BLUE_68x.png?v=12093810760273079321")','beige': 'url("//abcbrand.co/cdn/shop/files/BEIGE_68x.png?v=2834548894470413601")','navy': 'url("//abcbrand.co/cdn/shop/files/NAVY_68x.png?v=17283675896062648445")','olive': 'url("//abcbrand.co/cdn/shop/files/OLIVE_68x.png?v=3429083367823819768")','natural': 'url("//abcbrand.co/cdn/shop/files/NATURAL_68x.png?v=12100267186901385856")','cashmere-blue-steel-grey': 'url("//abcbrand.co/cdn/shop/files/CASHMERE_BLUE_STEEL_GREY_68x.png?v=8574")','cashmere-blue-orange': 'url("//abcbrand.co/cdn/shop/files/CASHMERE_BLUE_ORANGE_68x.png?v=8574")',};

    this.triggers = ['colors',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);
